const moundVisitHelper = (eventType, description, event) => {
    // non-mound visit events
    if (eventType !== 'mound_visit' && eventType !== 'game_advisory') {
        return false
    }

    if (eventType === 'mound_visit') {
        return true;
    }

    // check game advisory
    if (eventType === 'game_advisory') {
        const descLowercase = description?.toLowerCase();
        const eventLowercase = event?.toLowerCase();
        if (descLowercase?.indexOf('mound visit') > -1 || eventLowercase?.indexOf('visita a la lomita') > -1) {
            return true;
        }
    }
    
    return false;
};

export default moundVisitHelper;